import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import {
  Box,
  Card,
  CardContent,
  TextField,
  Button,
  Typography,
  Stepper,
  Step,
  StepLabel,
  Stack,
  Alert,
  useMediaQuery,
} from '@mui/material';

const STEPS = ['E-mail firmowy', 'Weryfikacja', 'Gotowe'];

function Register() {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [step, setStep] = useState(0);
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');

  const handleVerify = (e) => {
    e.preventDefault();
    setStep(2);
    setTimeout(() => navigate('/onboarding'), 1200);
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'background.default',
        p: { xs: 2, sm: 3 },
      }}
    >
      <Card sx={{ width: '100%', maxWidth: 480, borderRadius: 4 }}>
        <CardContent sx={{ p: { xs: 3, sm: 4 } }}>
          <Typography variant="h5" fontWeight={700} align="center" gutterBottom>
            Załóż organizację
          </Typography>
          <Stepper
            activeStep={step}
            orientation={isMobile ? 'vertical' : 'horizontal'}
            sx={{ my: 3 }}
          >
            {STEPS.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>

          {step === 0 && (
            <form
              onSubmit={(e) => {
                e.preventDefault();
                setStep(1);
              }}
            >
              <Stack spacing={2}>
                <TextField
                  label="E-mail firmowy"
                  type="email"
                  fullWidth
                  required
                  helperText="Wysłamy link weryfikacyjny na ten adres."
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <Button type="submit" variant="contained" fullWidth size="large">
                  Dalej
                </Button>
              </Stack>
            </form>
          )}

          {step === 1 && (
            <form onSubmit={handleVerify}>
              <Stack spacing={2}>
                <Alert severity="info" sx={{ textAlign: 'left' }}>
                  Wysłaliśmy kod na {email || 'adres e-mail'}.
                </Alert>
                <TextField
                  label="Kod weryfikacyjny"
                  fullWidth
                  required
                  value={code}
                  onChange={(e) => setCode(e.target.value)}
                />
                <Button type="submit" variant="contained" fullWidth size="large">
                  Zweryfikuj i przejdź dalej
                </Button>
              </Stack>
            </form>
          )}

          {step === 2 && (
            <Alert severity="success" sx={{ textAlign: 'left' }}>
              Domena zweryfikowana. Zaraz przekierujemy Cię do onboardingu organizacji.
            </Alert>
          )}
        </CardContent>
      </Card>
    </Box>
  );
}

export default Register;
